import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'grape' | 'blush';
};
export const CHECKOUT_URL = 'https://100-ai-prompts-for-supervisors.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'blush'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[65px] px-8 py-4 text-[17px]' : 'min-h-[58px] px-6 py-3.5 text-base';

  // blush = gold fill / black text (primary). grape = black fill / gold text.
  const skin = variant === 'blush' ? 'border-2 border-plum bg-grape-soft text-plum shadow-[0_10px_30px_-12px_rgba(143,107,14,0.75)] hover:bg-plum hover:text-grape-soft hover:shadow-[0_16px_40px_-12px_rgba(0,0,0,0.6)] focus-visible:ring-grape' : 'border-2 border-plum bg-plum text-grape-soft shadow-[0_10px_30px_-12px_rgba(0,0,0,0.6)] hover:bg-plum-soft focus-visible:ring-grape-soft';
  return <a href={href} className={cn('group inline-flex w-full max-w-[380px] items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2', skin, pad, className)} data-id="element-39" data-mp="19b9b6axif0t9">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-40" data-mp="1w81eqlmu0lca" />
    </a>;
}